import useIsomorphicLayoutEffect from "./global/useIsomorphicLayoutEffect";

// `overflow: hidden` stops the wheel but not touch scrolling on the root
// scroller; the only lock touch honours is taking the body out of flow, and
// that collapses the scrollport, so any `position: sticky` ancestor of the
// caller drops to its static position — off-screen once the page is scrolled.
// Only overlays that are themselves fixed-positioned may opt in; everything
// else gets the body-only overflow lock.
export const useBodyScrollLock = (
  isLocked = true,
  { lockViewport = false } = {}
) => {
  useIsomorphicLayoutEffect(() => {
    if (!isLocked) return;

    const root = document.documentElement;
    const { body } = document;
    const scrollY = window.scrollY;
    const original = {
      rootOverflow: root.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
    };

    body.style.overflow = "hidden";
    if (lockViewport) {
      root.style.overflow = "hidden";
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
    }

    return () => {
      body.style.overflow = original.bodyOverflow;
      if (lockViewport) {
        root.style.overflow = original.rootOverflow;
        body.style.position = original.bodyPosition;
        body.style.top = original.bodyTop;
        body.style.left = original.bodyLeft;
        body.style.right = original.bodyRight;
        body.style.width = original.bodyWidth;
        // out of flow means the offset is gone; `instant` because the global
        // `scroll-behavior: smooth` would otherwise animate the restore
        window.scrollTo({ top: scrollY, behavior: "instant" });
      }
    };
  }, [isLocked, lockViewport]);
};
